import { RouteObject } from "react-router-dom";
import { ProfilePage } from "./ui/ProfilePage";

export const mypageRoute: RouteObject = {
  path: "/mypage",
  element: <ProfilePage />,
};
